import gql from 'graphql-tag'
import { IDMTableDepartment } from '@api/types'
import { DMTableDepartmentFragment } from '@api/fragments'
import client from '../../stores/apollo'

interface Payload {
  data: {
    node: IDMTableDepartment
  }
}

export const query = gql`
  query Department($id: ID!) {
    node(id: $id) {
      ... on Department {
        ...DMTableDepartmentFragment
      }
    }
  }
  ${DMTableDepartmentFragment}
`

export default function details(variables: { id: string }): Promise<IDMTableDepartment> {
  return client.gql.query({ query, variables }).then(({ data: { node } }: Payload) => node)
}
